import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { RoleEntite } from '../entites/role';
import { TacheEntite } from '../entites/tache';
import { BaseService } from './base.service';
import { Message, MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class RoleService extends BaseService {

  private obtenirRolesUrl = environment.apiBaseUrl + 'employe/roles';
  private obtenirTachesUrl = environment.apiBaseUrl + 'employe/taches';
  private ajouterRoleUrl = environment.apiBaseUrl + 'employe/roles/ajouter';
  private modifierTachesRoleUrl = environment.apiBaseUrl + 'employe/roles/{roleId}/taches';
  private supprimerRoleUrl = environment.apiBaseUrl + 'employe/roles/{roleId}';


  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router,
    public messageService: MessageService
  ) {
    super(messageService, router);
  }

  /**
   * Obtient la liste de tous les rôles
   * @returns Observable contenant la liste des rôles
   */
  public obtenirRoles(): Observable<RoleEntite[]> {
    return this.http.get<RoleEntite[]>(this.obtenirRolesUrl)
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }

  /**
   * Obtient la liste de toutes les tâches disponibles
   * @returns Observable contenant la liste des tâches
   */
  public obtenirTaches(): Observable<TacheEntite[]> {
    return this.http.get<TacheEntite[]>(this.obtenirTachesUrl)
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }



  /**
   * Ajoute un nouveau rôle
   * @param role Données du rôle à créer
   * @returns Le rôle créé
   */
  public ajouterRole(role: RoleEntite): Observable<RoleEntite> {
    return this.http.post<RoleEntite>(this.ajouterRoleUrl, JSON.stringify(role), this.httpOptions)
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }

  /**
   * Modifie les tâches associées à un rôle spécifique
   * @param roleId ID du rôle à modifier
   * @param tacheIds Liste des IDs des tâches à associer au rôle
   * @returns Retourne true si la modification a réussi
   */
  public modifierTachesRole(roleId: number, tacheIds: number[]): Observable<boolean> {
    return this.http.post<boolean>(this.modifierTachesRoleUrl.replace('{roleId}', roleId.toString()), 
      JSON.stringify(tacheIds), this.httpOptions)
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }

  /**
   * Supprime un rôle (sauf SIHC_Administrateur)
   * @param roleId ID du rôle à supprimer
   * @returns Message de confirmation
   */
  public supprimerRole(roleId: number): Observable<Message> {
    return this.http.delete<Message>(this.supprimerRoleUrl.replace('{roleId}', roleId.toString()))
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }
}
